import React from 'react';
import { Clock } from 'lucide-react';
import { Translations } from '../../i18n/translations';

interface TimeLimitSettingsProps {
  dailyTimeLimit: number;
  onTimeLimitChange: (minutes: number) => void;
  t: Translations;
}

export const TimeLimitSettings: React.FC<TimeLimitSettingsProps> = ({
  dailyTimeLimit,
  onTimeLimitChange,
  t,
}) => {
  return (
    <div className="bg-white dark:bg-gray-800 border-2 border-gray-300 dark:border-gray-600 p-4 mb-4">
      <h3 className="font-bold mb-3 flex items-center gap-2 text-gray-900 dark:text-white">
        <Clock className="w-4 h-4" />
        {t.dailyTimeLimit}
      </h3>
      <p className="text-sm text-gray-600 dark:text-gray-400 mb-3">
        {t.dailyTimeLimitDesc}
      </p>
      <div className="flex items-center gap-4">
        <input
          type="range"
          min="5"
          max="120"
          step="5"
          value={dailyTimeLimit === 0 ? 120 : dailyTimeLimit}
          onChange={(e) => onTimeLimitChange(parseInt(e.target.value, 10))}
          className="flex-1"
          disabled={dailyTimeLimit === 0}
        />
        <span className="font-semibold text-lg w-24 text-right text-gray-900 dark:text-white">
          {dailyTimeLimit === 0 ? t.unlimited : `${dailyTimeLimit} ${t.min}`}
        </span>
      </div>
      <div className="flex gap-2 mt-3 flex-wrap">
        {[15, 30, 45, 60].map((mins) => (
          <button
            key={mins}
            onClick={() => onTimeLimitChange(mins)}
            className={`px-3 py-1 text-sm font-semibold border-2 ${
              dailyTimeLimit === mins
                ? 'bg-black text-white border-black dark:bg-white dark:text-black dark:border-white'
                : 'bg-white text-gray-700 border-gray-300 hover:bg-gray-100 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-600 dark:hover:bg-gray-600'
            }`}
          >
            {mins}{t.min}
          </button>
        ))}
        <button
          onClick={() => onTimeLimitChange(0)}
          className={`px-3 py-1 text-sm font-semibold border-2 ${
            dailyTimeLimit === 0
              ? 'bg-black text-white border-black dark:bg-white dark:text-black dark:border-white'
              : 'bg-white text-gray-700 border-gray-300 hover:bg-gray-100 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-600 dark:hover:bg-gray-600'
          }`}
        >
          {t.unlimited}
        </button>
      </div>
    </div>
  );
};
